import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

export function tempConvert(degrees_C) {
  return (degrees_C * 9) / 5 + 32;
}

export function Sparkline({
  my_data,
  metric_name,
  suggested_min,
  suggested_max,
}) {
  const options = {
    responsive: true,
    legend: {
      display: false,
    },
    tension: 0,
    plugins: {
      legend: {
        position: 'top',
        display: false,
      },
      title: {
        display: false,
        text: 'Water Temp (C)',
      },
    },
    elements: {
      line: {
        borderColor: '#000000',
        borderWidth: 1,
      },
      point: {
        radius: 0,
      },
    },
    scales: {
      y: {
        suggestedMin: suggested_min,
        suggestedMax: suggested_max,
        //   min: -5,
        //   max: 105,
        display: false,
        drawTicks: false,
      },
      x: {
        display: false,
        drawTicks: false,
      },
    },
    animation: {
      duration: 0,
    },
  };

  const data = {
    labels: my_data.map((d) => d.send_time),
    datasets: [
      {
        label: metric_name,
        fill: true,
        data: my_data.map((d) => d.metrics[metric_name][2]),
        borderColor: 'rgb(255, 99, 132)',
        backgroundColor: 'rgba(255, 99, 132, 0.5)',
      },
    ],
  };
  return <Line options={options} data={data} width="100px" />;
}
